/*
  A small burst of confetti in the Magnum colours whenever something goes in
  the bag.

  Nothing opens over the page when you add, so the moment can pass unnoticed.
  The button already says "Added to bag!" - this gives that a little lift.

  The confetti is drawn on one see-through canvas laid over the whole window,
  rather than inside the button: the button hides anything that strays past
  its edges, and confetti that cannot leave the button is not confetti. The
  canvas ignores the mouse entirely, so nothing underneath becomes harder to
  click, and it is taken away again the moment the last piece has fallen.
*/
(function () {
  // Straight from the shop: the deep green, the creams and sands, the
  // terracotta and the sage. No colour here is not already on the page.
  const COLOURS = ['#446049', '#eec1a2', '#f1daae', '#c8d3a6', '#c98150', '#334136'];

  const PIECES = 26;
  /*
    How hard the pieces are thrown, how fast they fall, how quickly the air
    slows them down, and how long they last. Thrown hard and pulled down hard,
    so the whole thing is over in under a second - a gentler fall looked like
    slow motion.
  */
  const SPEED = 14;
  const GRAVITY = 0.85;
  const DRAG = 0.995;
  const LIFE = 850;

  let canvas = null;
  let ctx = null;
  let pieces = [];
  let frame = null;
  let last = 0;

  function fitCanvas() {
    // Two device pixels per page pixel is enough to look sharp on a phone
    // without asking the browser to paint four times the area.
    const ratio = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.floor(window.innerWidth * ratio);
    canvas.height = Math.floor(window.innerHeight * ratio);
    canvas.style.width = window.innerWidth + 'px';
    canvas.style.height = window.innerHeight + 'px';
    ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
  }

  function openCanvas() {
    if (canvas) return;
    canvas = document.createElement('canvas');
    canvas.className = 'magnum-confetti';
    // Kept out of the way of screen readers - there is nothing here to read.
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText =
      'position:fixed;top:0;left:0;pointer-events:none;z-index:2147483000;';
    ctx = canvas.getContext('2d');
    document.body.appendChild(canvas);
    fitCanvas();
    window.addEventListener('resize', fitCanvas);
  }

  function closeCanvas() {
    if (!canvas) return;
    window.removeEventListener('resize', fitCanvas);
    canvas.remove();
    canvas = null;
    ctx = null;
  }

  function addPieces(x, y) {
    for (let i = 0; i < PIECES; i += 1) {
      // Thrown upwards in a fan, a little more to one side or the other each
      // time, so two bursts never look like the same burst.
      const angle = -Math.PI / 2 + (Math.random() - 0.5) * 1.7;
      const speed = SPEED * (0.55 + Math.random() * 0.7);
      pieces.push({
        x: x + (Math.random() - 0.5) * 30,
        y: y + (Math.random() - 0.5) * 10,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        width: 5 + Math.random() * 5,
        height: 8 + Math.random() * 5,
        colour: COLOURS[Math.floor(Math.random() * COLOURS.length)],
        // Each piece spins at its own pace, in its own direction, so the
        // burst turns over on itself instead of moving as one sheet.
        spin: (Math.random() - 0.5) * 0.5,
        turn: Math.random() * Math.PI * 2,
        age: 0,
      });
    }
  }

  function draw(now) {
    // Measured in real time rather than in frames, so it runs at the same
    // speed on a slow phone as on a fast laptop.
    const step = Math.min(now - last, 50) / 16.667;
    last = now;

    ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);

    pieces = pieces.filter((piece) => {
      piece.age += step * 16.667;
      piece.vy += GRAVITY * step;
      piece.vx *= DRAG;
      piece.vy *= DRAG;
      piece.x += piece.vx * step;
      piece.y += piece.vy * step;
      piece.turn += piece.spin * step;

      // Gone once it has faded out, or once it has fallen off the bottom.
      if (piece.age >= LIFE || piece.y - 40 > window.innerHeight) return false;

      // The last of its life is spent fading, so nothing ever blinks out.
      const left = 1 - piece.age / LIFE;
      ctx.globalAlpha = Math.min(1, left * 2.5);
      ctx.save();
      ctx.translate(piece.x, piece.y);
      ctx.rotate(piece.turn);
      // Squeezing the width as it turns reads as a flat scrap of paper
      // flipping over, without drawing anything in three dimensions.
      ctx.scale(Math.max(0.15, Math.abs(Math.cos(piece.turn * 1.6))), 1);
      ctx.fillStyle = piece.colour;
      ctx.fillRect(-piece.width / 2, -piece.height / 2, piece.width, piece.height);
      ctx.restore();
      return true;
    });

    ctx.globalAlpha = 1;

    if (pieces.length) {
      frame = requestAnimationFrame(draw);
    } else {
      frame = null;
      closeCanvas();
    }
  }

  /*
    Throws a burst from the middle of the button that was pressed. Given
    nothing to aim at, it comes from the middle of the window instead.
  */
  window.magnumConfetti = function (button) {
    // Anyone who has asked their computer for less movement gets none of this.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (document.hidden) return;

    let x = window.innerWidth / 2;
    let y = window.innerHeight / 2;

    if (button && button.getBoundingClientRect) {
      const box = button.getBoundingClientRect();
      // A button scrolled out of sight would fire confetti at nothing.
      if (!box.width && !box.height) return;
      x = box.left + box.width / 2;
      y = box.top + box.height / 2;
    }

    openCanvas();
    addPieces(x, y);

    if (!frame) {
      last = performance.now();
      frame = requestAnimationFrame(draw);
    }
  };
})();
